var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"modal-1",attrs:{"size":"lg","centered":"","title":"Caja","hide-footer":""},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_vm._v("\r\n            Detalles de Pago\r\n        ")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }